import React from "react";
import "./operation-button.css";
import { connect } from "react-redux";
import bindAll from 'lodash.bindall';
import Button from "antd/lib/button";

class OperationButton extends React.Component {
  constructor(props) {
    super(props)
    bindAll(this, [
      'onClick'
    ])
  }
  onClick() {
    if (typeof this.props.getAction !== 'function') {
      return
    }
    let actions = this.props.getAction()
    if (Array.isArray(actions)) {
      actions.forEach(action => this.props.dispatch(action))
    } else {
      this.props.dispatch(this.props.getAction())
    }
  }
  render() {
    return (
      <Button 
        className="xes-button" 
        style={{
          color: '#4A82F7',
          borderRadius: '0.25rem',
          outline: 'none',
          border: 'none',
          fontSize: '0.88rem',
          fontWeight: '600'
        }} 
        onClick={this.onClick}
        loading={this.props.loading}
        disabled={this.props.disabled}
      >
        {this.props.children}
      </Button>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatch
})
const mapStateToProps = (state) => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OperationButton)